
export default function(prevValue, newValue, initialChar, provider) {
	const totalChangedChars = newValue.length - prevValue.length

	let count = 0
	let str = '', value
	if (totalChangedChars <= 0) {
		value = newValue
	} else {
		while (count < totalChangedChars) {
			const n = provider.original.indexOf(newValue.substr(initialChar + count, 1))
			str += (n!==-1 ? provider.replacement[n] : '')
			count += 1
		}
		value = newValue.substr(0, initialChar) + str + newValue.substr(initialChar + totalChangedChars)
	}
	return value
}
